import React from 'react';
import { Box, Typography } from '@mui/material';

// ページ見出し共通 primitive。
// title + 任意 description + 右側 actions スロット。
// 下マージン (mb:3 = 24px) を固定で持つことで「見出しが次の要素にかぶる」を撲滅。

export default function PageHeader({ title, description, actions }) {
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'flex-start',
        justifyContent: 'space-between',
        gap: 2,
        mb: 3,
      }}
    >
      <Box>
        <Typography variant="h5" sx={{ fontWeight: 600 }}>
          {title}
        </Typography>
        {description && (
          <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5 }}>
            {description}
          </Typography>
        )}
      </Box>
      {actions && (
        <Box sx={{ display: 'flex', gap: 1, flexShrink: 0 }}>{actions}</Box>
      )}
    </Box>
  );
}
